import { render, staticRenderFns } from "./multiItem.vue?vue&type=template&id=2994cd98"
import script from "./multiItem.vue?vue&type=script&lang=js"
export * from "./multiItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports